import { jsx as _jsx } from 'react/jsx-runtime.js';
import { RegistrationSuccessModal } from '@stepstone/registration-confirmation-success-modal';
import { useAppSelector } from '../../hooks/redux/index.js';
import { registrationConfigSelector } from '../../core/siteConfig/siteConfigSlice.js';
import { showRegistrationSuccessfulModalSelector } from '../../forms/Registration/registrationSlice.js';
import { redirectionUrlSelector } from '../../core/sourceData/sourceDataSlice.js';
export const CVUploadModal = () => {
    const showRegistrationSuccessfulModal = useAppSelector(showRegistrationSuccessfulModalSelector);
    const { registrationSuccessModal: { redirectToJobSearchUrl, redirectToProfileUrl }, } = useAppSelector(registrationConfigSelector);
    const hideModal = () => {
        window.location.href = redirectToProfileUrl;
    };
    const redirectionUrl = useAppSelector(redirectionUrlSelector);
    return (_jsx(RegistrationSuccessModal, { open: showRegistrationSuccessfulModal, setOpen: hideModal, redirectToProfileUrl: redirectToProfileUrl, redirectToJobSearchUrl: redirectionUrl ?? redirectToJobSearchUrl }));
};
//# sourceMappingURL=CVUploadModal.js.map